<template>
  <div class="reviews">
    <p class="reviews__title">Cómo nos valoran</p>
    <div class="reviews__container">
      <p class="reviews__average">{{ score }}</p>
      <div class="reviews__stars__container">
        <div class="reviews__stars">
          <i class="reviews__stars__icon"></i>
          <i class="reviews__stars__icon"></i>
          <i class="reviews__stars__icon"></i>
          <i class="reviews__stars__icon"></i>
          <i class="reviews__stars__icon"></i>
          <div class="absolute top-0 right-0 h-full bg-neutral-lightest" :style="noStarsStyle"></div>
        </div>
        <img class="reviews__logo" src="/img/web/icons/Google.svg" alt="Logo Google" />
      </div>
    </div>
    <a class="reviews__link" :href="reviewsUrl" target="_blank">Ver todas las valoraciones</a>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    noStarsStyle() {
      return `width: ${((5 - this.score) / 5) * 100}%`;
    },
    reviewsUrl() {
      const ua = navigator.userAgent;
      if (
        /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) ||
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
      ) {
        return 'https://www.google.com/search?q=trioteca+reviews&oq=trioteca+reviews#lkt=LocalPoiReviews&trex=m_t:lcl_akp,rc_f:nav,rc_ludocids:15823220965021819260,rc_q:TRIOTECA,ru_q:TRIOTECA,trex_id:Rpvenc';
      }
      return 'https://www.google.com/search?q=trioteca+reviews&oq=trioteca+reviews#lrd=0x12a4970918dcf147:0xdb975fa1f6a3a17c,1';
    },
  },
};
</script>
